import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import CreditSimulatorViewModel from "@/viewmodels/dialogs/CreditSimulatorViewModel";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreditSimuilatorDialog',
  setup(__props, { expose: __expose }) {

const viewModel = new CreditSimulatorViewModel();

__expose({
  openDialog: () => viewModel.openDialog(),
  closeDialog: () => viewModel.closeDialog(),
  closeMenu: () => viewModel.closeMenu(),
});

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _unref(viewModel).dialog.value,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(viewModel).dialog.value) = $event)),
    persistent: "",
    "max-width": "800px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex justify-between align-center" }, {
            default: _withCtx(() => [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-subtitle-1 font-weight-bold" }, "Simulador de Crédito", -1)),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "flat",
                icon: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(viewModel).closeDialog()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("mdi-close")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, { class: "pa-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { dense: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "text-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-bold" }, {
                            default: _withCtx(() => _cache[10] || (_cache[10] = [
                              _createTextVNode("Cuota Mensual")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_card_text, { class: "text-h4 font-weight-bold" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" S/ " + _toDisplayString(_unref(viewModel).monthlyPayment.value?.toFixed(2) ?? 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { dense: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _unref(viewModel).amount.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(viewModel).amount.value) = $event)),
                            label: "Monto del Crédito (S/)",
                            variant: "outlined",
                            type: "number",
                            rules: _unref(viewModel).amountRules,
                            required: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_menu, {
                            modelValue: _unref(viewModel).paymentDateMenu.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(viewModel).paymentDateMenu.value) = $event)),
                            transition: "scale-transition",
                            "offset-y": ""
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_text_field, _mergeProps({
                                modelValue: _unref(viewModel).formattedPaymentDate.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(viewModel).formattedPaymentDate.value) = $event)),
                                label: "Hoy",
                                variant: "outlined"
                              }, props, {
                                readonly: "",
                                required: ""
                              }), null, 16, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { dense: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            modelValue: _unref(viewModel).installments.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(viewModel).installments.value) = $event)),
                            items: _unref(viewModel).installmentOptions,
                            label: "Número de Cuotas",
                            variant: "outlined",
                            required: "",
                            rules: _unref(viewModel).installmentRules
                          }, null, 8, ["modelValue", "items", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _unref(viewModel).rate.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(viewModel).rate.value) = $event)),
                            label: "Tasa de Interés (%)",
                            variant: "outlined",
                            type: "number",
                            rules: _unref(viewModel).rateRules,
                            required: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { dense: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            height: "50",
                            block: "",
                            color: "primary",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(viewModel).calculateSimulation())),
                            disabled: !_unref(viewModel).isFormValid
                          }, {
                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                              _createTextVNode(" Simular Crédito ")
                            ])),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})